import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IActivityLogsData } from "../../api/agentActivityLog/index.types";

export interface IAgentsActivityLogsState {
  data: {
    logs: IActivityLogsData[];
    count: number;
  };
  loading: boolean;
}

const initialState: IAgentsActivityLogsState = {
  data: {
    logs: [],
    count: 0,
  },
  loading: false,
};

const index = createSlice({
  name: "agentsLogsActivity",
  initialState,
  reducers: {
    fetchLogsRequest: (state) => {
      state.loading = true;
    },
    fetchLogsSuccess: (
      state,
      action: PayloadAction<{
        logs: IActivityLogsData[];
        count: number;
      }>
    ) => {
      state.loading = false;
      state.data.count = action.payload.count;
      state.data.logs = action.payload.logs;
    },
    fetchLogsFailed: (state) => {
      state.loading = false;
    },
  },
});

export const agentsLogsActivityActions = index.actions;
export default index.reducer;
